// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2seo6","icon":"SortAdornment_icon__1t7hx","up":"SortAdornment_up__2nHao","down":"SortAdornment_down__8Mrtr","active":"SortAdornment_active__2L6EW"};